import { Salzschiff, StadlPauraSalzkuefel } from "../../Utils/GlbLoaderArtefakte.jsx";
import ExperienceModelViewer from "../ExperienceModelViewer.jsx";

export default function ArtefaktBundlesPapiermacher({ currentMuseumId }) {
  const { salzschiff } = Salzschiff();
  const { stadlPauraSalzkuefel } = StadlPauraSalzkuefel();

  const artefactArray = [salzschiff, stadlPauraSalzkuefel];

  return <ExperienceModelViewer modelArray={artefactArray} currentMuseumId={currentMuseumId} />;
}
